import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
} from "@mui/material";

const CreateFolderDialog = ({
  open,
  onClose,
  folderName,
  setFolderName,
  onCreate,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 3,
        p: 2,
      },
    }}
  >
    <DialogTitle>
      <Typography variant="h6" fontWeight="bold">
        Create New Folder
      </Typography>
    </DialogTitle>

    <DialogContent>
      <Typography variant="body2" color="text.secondary" mb={1}>
        Enter a name for your new folder:
      </Typography>
      <TextField
        autoFocus
        fullWidth
        variant="outlined"
        placeholder="e.g., Project Files"
        value={folderName}
        onChange={(e) => setFolderName(e.target.value)}
        sx={{ mt: 1 }}
      />
    </DialogContent>

    <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
      <Button onClick={onClose} variant="text" color="inherit">
        Cancel
      </Button>
      <Button
        onClick={onCreate}
        variant="contained"
        disabled={!folderName.trim()}
      >
        Create
      </Button>
    </DialogActions>
  </Dialog>
);

export default CreateFolderDialog;
